var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.471,
    height: 30.465,
    viewBox: "0 0 30.471 30.465",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-svgrepo-com",
    transform: "translate(0.25 0.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53079",
    "data-name": "Group 53079",
    transform: "translate(0 0.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71799",
    "data-name": "Path 71799",
    d: "M121.636,16.054A8,8,0,1,0,113.6,8.018,7.988,7.988,0,0,0,121.636,16.054Zm0-13.515a5.541,5.541,0,0,1,5.547,5.485,5.547,5.547,0,0,1-11.093-.006A5.536,5.536,0,0,1,121.636,2.539Z",
    transform: "translate(-106.653 -0.05)",
    fill: "#8b8b8b",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71800",
    "data-name": "Path 71800",
    d: "M20.4,273.511a1.287,1.287,0,0,0-1.339.385l-4.079,4.654L10.9,273.9a1.335,1.335,0,0,0-1.339-.385C3.761,275.425,0,280.14,0,285.43a1.281,1.281,0,0,0,1.278,1.278H28.693a1.281,1.281,0,0,0,1.278-1.278C29.965,280.14,26.2,275.425,20.4,273.511ZM2.611,284.219c.514-3.5,3.064-6.5,7.014-8.03l4.464,5.1a1.2,1.2,0,0,0,1.847,0l4.464-5.1c3.889,1.529,6.507,4.587,7.014,8.03Z",
    transform: "translate(0 -256.742)",
    fill: "#8b8b8b",
    stroke: "#fff",
    strokeWidth: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSvgrepoCom);
export default __webpack_public_path__ + "static/media/user-svgrepo-com.40d0fd8eb570507f2f5dfab320f42644.svg";
export { ForwardRef as ReactComponent };